import { useCallback } from 'react';
import { DateVectorRange } from '../../utils/DateVectorRange';
export var useDatePickerTodayButton = function useDatePickerTodayButton(_ref, _) {
  var currentDateVector = _ref.currentDateVector,
    onDateTimeChange = _ref.onDateTimeChange,
    setDisplayedDateVector = _ref.setDisplayedDateVector;
  var onTodayButtonClick = useCallback(function () {
    var newVector = new DateVectorRange(currentDateVector.clone(), currentDateVector.clone());
    onDateTimeChange(newVector); // change value
    if (newVector.dateStart) {
      setDisplayedDateVector(newVector.dateStart); // update the display
    }
  }, [currentDateVector, onDateTimeChange, setDisplayedDateVector]);
  return {
    onTodayButtonClick: onTodayButtonClick
  };
};